import React from 'react';
import "./letsgo.scss";

//images
import imgLetsgo from "../../../assets/connectors/Letsgo.png";
import { useTranslation } from 'react-i18next';

const Letsgo = () => {
    const {t} = useTranslation()

    return (
        <div className="container-Letsgo">
            <div className="img-Letsgo">
                <img src={imgLetsgo} alt="" />
            </div>
            <div className="texts-Letsgo">
                <h1>
                    LET'S GO?
                </h1>
                <p>{t("connectors.lets_go.section_text")}</p>
                <a href="/form">
                    <button id="btn-Letsgo">{t("buttons.demo_btn_text")}</button>
                </a>
            </div>
        </div>
    )
}

export default Letsgo;